var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('v-app',[_c('app-sidebar'),_vm._v(" "),_c('app-toolbar'),_vm._v(" "),_c('app-content'),_vm._v(" "),_c('connection-checker'),_vm._v(" "),_c('service-worker')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }